import { authUrl } from '../Constants/Api';

const LOGIN_URL = `${authUrl}/connect/microsoft`;
const CODE_EXCHANGE_URL = `${authUrl}/connect/microsoft/callback`;

export function loginRedirect(prompt = false, state) {
	const origin = encodeURIComponent(window.location.origin);
	const encodedState = encodeURIComponent(state || '');
	let url = `${LOGIN_URL}?redirect_uri=${origin}&state=${encodedState}`;

	// Prompt user to select an account
	if (prompt) {
		url += '&prompt=select_account';
	}

	window.location.href = url;
}

export async function exchangeCode(code) {
	const resp = await fetch(`${CODE_EXCHANGE_URL}?code=${code}&redirect_uri=${window.location.origin}`, {
		method: 'GET',
		credentials: 'include',
	}).then((res) => res.json());

	if (resp.error) {
		throw new Error(resp.error.error_description || resp.error.error);
	}
	return resp;
}

export function generateUserFromToken(userToken) {
	console.log('generateUserFromToken', userToken);
	if (userToken?.id_token) {
		// If we loaded the token, parse it to get the username
		const [, rawPayload] = userToken.id_token.split('.');
		const payload = JSON.parse(atob(rawPayload));

		const userId = payload.oid;
		const email = payload.email || payload.preferred_username;
		let displayName = payload.name || email;
		if (displayName.includes('@')) displayName = displayName.split('@')[0];

		let username = email;
		if (username.includes('@')) username = username.split('@')[0];

		let user = {
			userId,
			displayName,
			email,
			username,
			token: userToken,
		};
		return user;
	}
}
